'use client';

import { useEcomStoreSelector, useUiStoreSelector } from '@/data';
import { useBundleSpecial } from '@/hooks';
import { ProductValidatorModal } from '../ProductValidatorModal';
import { useSpecialsContext } from 'context/specials';

const BogoValidatorModal = () => {
  const { line_items, setState } = useEcomStoreSelector(['line_items']);
  const { removeBUYProductBundleId, setRemoveBUYProductBundleId } =
    useSpecialsContext();
  const {
    is_cart_open,
    setState: setUiState,
    is_special_bogo_modal_open,
  } = useUiStoreSelector(['is_cart_open', 'is_special_bogo_modal_open']);

  const { currentBundleProducts } = useBundleSpecial({
    id: removeBUYProductBundleId ?? '',
  });

  if (is_cart_open && is_special_bogo_modal_open) {
    setUiState({ is_cart_open: false });
  }

  const dealLineIds = new Set(
    currentBundleProducts.map(line => line._id).filter(Boolean),
  );

  const handleCloseModal = () => {
    setUiState({ is_special_bogo_modal_open: false });
    setRemoveBUYProductBundleId(null);
  };

  const handleSubmit = () => {
    const filteredItems =
      line_items?.filter(item => !dealLineIds.has(item._id)) ?? [];

    setState({ line_items: [...filteredItems] });
    setRemoveBUYProductBundleId(null);
    setUiState({ is_special_bogo_modal_open: false });
  };

  return (
    <ProductValidatorModal
      alertMessage="Removing this item will also remove all related Promo items from the cart"
      cancelButtonLabel="Keep items"
      handleCloseModal={handleCloseModal}
      handleSubmit={handleSubmit}
      heading="Confirm Product Removal"
      isModalOpen={is_special_bogo_modal_open}
      products={currentBundleProducts}
      submitButtonLabel="Remove All Items"
    />
  );
};

export { BogoValidatorModal };
